import Vue from 'vue'
import Element from 'element-ui'

// import '../element-variables.scss'
//element-variables.scss 的@import指令会导致加载编译卡住很久,因此使用elementui的在线主题生成工具生成包然后引入
import './element-#3DA9FC/index.css'

Vue.use(Element)
